import {api} from '../helpers/api';
import utils from '../helpers/utils';

export const PLAN_DETAILS_REQUEST = 'PLAN_DETAILS_REQUEST';
export const PLAN_DETAILS_FAILURE = 'PLAN_DETAILS_FAILURE';
export const PLAN_DETAILS_SUCCESS = 'PLAN_DETAILS_SUCCESS';

/**
 * Get plan details
 * @param {string} userAccountId - User account id
 * @return {function} - Thunk to be dispatched
 */
export function getPlanDetails(userAccountId: string) {
  const url = utils.getPlanDetails();
  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      account_id: userAccountId,
    },
    credentials: 'include',
  };
  return api(url, config, getPlanDetailsRequest(), getPlanDetailsSuccess, getPlanDetailsFailure);
}

/**
 * Plan details request
 *
 * @return {Object} - Returns a redux action to handle request
 */
function getPlanDetailsRequest() {
  return {
    type: PLAN_DETAILS_REQUEST,
  };
}

/**
 * Plan details success
 *
 * @param  {Object} payload - contains featureList, featureDetails data.
 * @return {Object} - Returns a redux action to handle success
 */
function getPlanDetailsSuccess(payload: $TSFixMe) {
  return {
    type: PLAN_DETAILS_SUCCESS,
    payload,
  };
}

/**
 * Plan details failure
 * @return {Object} - Returns a redux action to handle failure
 */
function getPlanDetailsFailure() {
  return {
    type: PLAN_DETAILS_FAILURE,
  };
}
